// import staffPopup from "./staff-popup";
import staffPopup from "./staff-popup";

jQuery(document).ready(() => {
	// $(".staff-container").on("click", 'a.staff-popup-js', function () {
	// 	// $.fancybox.open($(this));
	// });
	let activeTerms = [];

	$('.staff__filter li').on('click', function () {
		let dataId = $(this).data('filter');
		const postType = $('.filter-bar').data('type'),
			taxonomy = $('.filter-bar').data('taxonomy'),
			idPage = $('.staff-container').data('id-page');

		$(this).toggleClass('active');

		if ($(this).hasClass('active')) {
			activeTerms.push(dataId);
		} else {
			activeTerms.splice($.inArray(dataId, activeTerms), 1);
		}

		$.ajax({
			url: themeVars.ajaxurl,
			type: "POST",
			data: {
				action: "filter_by_terms",
				post_type: postType,
				taxonomy: taxonomy,
				terms: activeTerms,
				id_page: idPage,
			},
			beforeSend: function () {
				$('.staff__filter').addClass('locked');
			},
			success: function (data) {
				console.log('success');
				$('.staff-container').html(data.staff_html);
				staffPopup();
				//match height for collaborators page
				$(".staff-elem a").matchHeight();
			},
		});
	});
});



// WEBPACK FOOTER //
// ./scripts/modules/filter-terms.js